module.exports = __webpack_public_path__ + "static/media/07.29d92ba6.jpg";